import React from "react";
import "../css/space-background.css";

interface SpaceIcon {
  icon: string;
  className: string;
}

const icons: SpaceIcon[] = [
  { icon: "fa-solid fa-star", className: "space-icon space-icon-1" },
  { icon: "fa-regular fa-star", className: "space-icon space-icon-2" },
  { icon: "fa-solid fa-star", className: "space-icon space-icon-3" },
  { icon: "fa-regular fa-star", className: "space-icon space-icon-4" },
  { icon: "fa-solid fa-star", className: "space-icon space-icon-5" },
  { icon: "fa-solid fa-star", className: "space-icon space-icon-6" },
  { icon: "fa-regular fa-star", className: "space-icon space-icon-7" },
  { icon: "fa-solid fa-star", className: "space-icon space-icon-8" },
  { icon: "fa-solid fa-star", className: "space-icon space-icon-9" },
  { icon: "fa-regular fa-star", className: "space-icon space-icon-10" },
  { icon: "fa-solid fa-star", className: "space-icon space-icon-11" },
  { icon: "fa-regular fa-star", className: "space-icon space-icon-12" },
  { icon: "fa-solid fa-star", className: "space-icon space-icon-13" },
  { icon: "fa-regular fa-star", className: "space-icon space-icon-14" },
  { icon: "fa-solid fa-star", className: "space-icon space-icon-15" },
  { icon: "fa-regular fa-star", className: "space-icon space-icon-16" },
  { icon: "fa-solid fa-star", className: "space-icon space-icon-17" },
  { icon: "fa-regular fa-star", className: "space-icon space-icon-18" },
  { icon: "fa-solid fa-star", className: "space-icon space-icon-19" },
  { icon: "fa-regular fa-star", className: "space-icon space-icon-20" },
];

const SpaceBackground: React.FC = () => (
  <div className="space-background" aria-hidden="true">
    {icons.map((item, i) => (
      <i key={i} className={`${item.icon} ${item.className}`} />
    ))}
  </div>
);

export default SpaceBackground;
